import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-follow-ups-form',
	imports: [CommonModule, FormsModule],
  providers: [DatePipe],
	templateUrl: './follow-ups-form.component.html',
	styleUrl: './follow-ups-form.component.scss',
})
export class FollowUpsFormComponent {
  // @Input() action: any;
  @Input() inq_id: any;
  @Input() isEdit: any;

  base = 'follow_ups';		// important for API calls

  user: any = '';
  errMsg = '';
  okMsg  = '';
  enquiries: any = [];
  follow_ups: any = [];
  
  leadStatuses: any = [];
  counsellors: any = [{'id': 1, 'name': 'Jagmeet'}, {'id': 2, 'name': 'Arun Sharma'}, {'id': 3, 'name': 'Vipin Mehra'}];
  today = new Date().toISOString().split('T')[0];
  followUpModes: any = [];
  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  localeDate: any = new Date().toLocaleDateString('en-IN');
  loading = false;
  headers: any = null;
	isReadonly = true;

  frmDataX: any = {};
  frmData: any = {
    id: null, 
    inq_id: 0, 
    fup_mode: '', 
    fup_notes: '', 
    lead_status: '', 
    fup_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
    next_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
    fup_uid: 0
  }

  constructor(public dataService: DataService) {
    //
  }

  ngOnChanges() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

    this.frmData.inq_id = this.inq_id || 0;
    this.frmData.fup_uid = this.user.id;
  }

  ngOnInit() {
    this.followUpModes = this.dataService.inquiry_mode;
    this.leadStatuses = this.dataService.lead_status;

		this.loading = true;
    this.dataService.getAllRecords('inquiries').then((res: any) => {
      this.enquiries = res;
      this.loading = false;
    });
  }

	resetForm() {
		this.frmData = {
      id: null, 
      inq_id: this.inq_id || 0, 
      fup_mode: '', 
      fup_notes: '', 
      lead_status: '', 
      fup_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      next_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      fup_uid: 0
    }
  }

  doSave() {
    this.loading = true;
    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        // this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        // this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }
}
